import { where } from 'firebase/firestore'

import helpers from '../commonHelpers/helpers'
import { calculateAge, getConvertedData } from '../models/interface.helper'

import FirestoreService from '../services/firestoreService'

import { UserDocumentModel } from '../models/user-documents/user-documents.model'

import { TEventPaperwork } from '../models/event-review-publish/event-review-publish.interface'
import { IUserDocument } from '../models/user-documents/user-documents.interface'
import { IRiderTeamMemberInterface } from '../models/rider-team-member/riderTeamMember.interface'
import { IUserInterface } from '../models/users/user.interface'
import { IEventDetails } from '../models/event-details/event-details.interface'

import fakeDocumentList, { IDocumentList } from '../fakeData/fakeDocumentList'
import { CONST } from '../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

export const getFilteredPaperwork = (EventPaperwork: TEventPaperwork | null) => {
  let fakePaperworkFoundOnIndex = -1
  let fakePaperworkDocumentsList_ = fakeDocumentList ?? []
  let filteredPaperworkDocuments: typeof fakeDocumentList = []

  try {
    const { emptyVarName, emptyVarValue } = helpers.findEmptyVal({
      EventPaperwork,
    })

    if (emptyVarName) {
      console.error(`${emptyVarName} is [${emptyVarValue}]`)
      return []
    }

    Object.entries(EventPaperwork ?? {}).forEach(([key, value]) => {
      fakePaperworkFoundOnIndex = -1

      if (value)
        fakePaperworkFoundOnIndex = fakePaperworkDocumentsList_.findIndex((currFakeDoc) => {
          return currFakeDoc.key === key
        })

      if (fakePaperworkFoundOnIndex !== -1)
        filteredPaperworkDocuments.push(fakePaperworkDocumentsList_[fakePaperworkFoundOnIndex])
    })
    return filteredPaperworkDocuments
  } catch (error) {
    console.error(error, 'error')
    return []
  }
}

const createUserDocuments = async (userDocuments: IUserDocument) => {
  return (
    (await FirestoreService.createItem(COLLECTIONS.USERS_DOCUMENTS.NAME, userDocuments))?.id ?? null
  )
}

const updateUserDocuments = async (userDocument: IUserDocument) => {
  await FirestoreService.updateItem(
    COLLECTIONS.USERS_DOCUMENTS.NAME,
    userDocument.id,
    new UserDocumentModel(userDocument).toFirestore()
  )
}

export const saveUserDocuments = async ({
  filteredPaperworkDocuments,
  ridersTeamMembersToAdd,
  ridersTeamMembersToUpdate,
  eventDetails,
  competitor,
}: {
  filteredPaperworkDocuments: IDocumentList
  ridersTeamMembersToAdd: IRiderTeamMemberInterface[]
  ridersTeamMembersToUpdate: IRiderTeamMemberInterface[]
  eventDetails: IEventDetails
  competitor: IUserInterface
}) => {
  let id: string | null = null

  const userDocumentsToAdd: IUserDocument[] = []
  const userDocumentsToUpdate: IUserDocument[] = []

  try {
    for (const document of filteredPaperworkDocuments) {
      if ([...ridersTeamMembersToAdd, ...ridersTeamMembersToUpdate]) {
        for (const ridersTeamMember of [...ridersTeamMembersToAdd, ...ridersTeamMembersToUpdate]) {
          const usersDocumentsSnapshot = await FirestoreService.filterItems(
            COLLECTIONS.USERS_DOCUMENTS.NAME,
            [
              where(
                COLLECTIONS.USERS_DOCUMENTS.FIELDS.SIGNATORY_ID.KEY,
                '==',
                ridersTeamMember.teamMemberId
              ),
              where(
                COLLECTIONS.USERS_DOCUMENTS.FIELDS.EVENT_ID.KEY,
                '==',
                eventDetails.competitionId
              ),
              where(
                COLLECTIONS.USERS_DOCUMENTS.FIELDS.RIDER_ID.KEY,
                '==',
                ridersTeamMember.riderId
              ),
              where(
                COLLECTIONS.USERS_DOCUMENTS.FIELDS.DOCUMENT_NAME.KEY,
                '==',
                document.document_name
              ),
              where(
                COLLECTIONS.USERS_DOCUMENTS.FIELDS.SIGNATORY_DEFAULT_ROLE.KEY,
                '==',
                ridersTeamMember.teamMemberRole
              ),
            ]
          )

          let age = calculateAge(ridersTeamMember.teamMemberDob)
          if (usersDocumentsSnapshot.size <= 0 && age >= 18) {
            userDocumentsToAdd.push(
              getConvertedData({
                status: 'Not Signed',

                eventId: eventDetails.competitionId,
                eventLogo: eventDetails.eventLogo,
                eventName: eventDetails.competitionName || '',

                activityUser: competitor?.userName ?? '',
                competitorId: competitor?.id ?? '',

                documentName: document.key,
                documentUrl: document.document_image[0],
                documentOriginalName: document.document_name,
                documentOwner: ridersTeamMember.teamMemberId,
                documentNameAsPerPdf: '',

                signatoryProfilePicture: ridersTeamMember.teamMemberProfilePicture,
                signatoryDefaultRole: ridersTeamMember.teamMemberRole,
                signatoryEmail: ridersTeamMember.teamMemberEmail,
                signatoryName: ridersTeamMember.teamMemberName,
                signatoryId: ridersTeamMember.teamMemberId,

                reminder: false,

                riderId: ridersTeamMember.riderId,
                riderName: ridersTeamMember.riderName,

                horseId: ridersTeamMember.horseId || null,
                horseName: ridersTeamMember.horseName || null,

                registrationDocId: ridersTeamMember.registrationDocId,
                riderTeamMemberDocId: ridersTeamMember.id ?? null,
                pageNumberToSignOn: null,
                coordinatesToSignOn: { x: null, y: null },

                created: new Date().toString(),
                modified: new Date().toString(),
              })
            )
          } else {
            if (age >= 18) {
              userDocumentsToUpdate.push(
                getConvertedData({
                  id: usersDocumentsSnapshot.docs[0].id,

                  eventId: eventDetails.competitionId,
                  eventLogo: eventDetails.eventLogo,
                  eventName: eventDetails.competitionName || '',

                  status: 'Not Signed',

                  activityUser: competitor?.userName ?? '',
                  competitorId: competitor?.id ?? '',

                  documentName: document.key,
                  documentUrl: document.document_image[0],
                  documentOriginalName: document.document_name,
                  documentOwner: ridersTeamMember.teamMemberId,
                  documentNameAsPerPdf: '',

                  signatoryProfilePicture: ridersTeamMember.teamMemberProfilePicture,
                  signatoryDefaultRole: ridersTeamMember.teamMemberRole,
                  signatoryEmail: ridersTeamMember.teamMemberEmail,
                  signatoryName: ridersTeamMember.teamMemberName,
                  signatoryId: ridersTeamMember.teamMemberId,

                  reminder: false,

                  riderId: ridersTeamMember.riderId,
                  riderName: ridersTeamMember.riderName,

                  horseId: ridersTeamMember.horseId || null,
                  horseName: ridersTeamMember.horseName || null,

                  registrationDocId: ridersTeamMember.registrationDocId,
                  riderTeamMemberDocId: ridersTeamMember.id ?? null,

                  pageNumberToSignOn: null,
                  coordinatesToSignOn: { x: null, y: null },

                  created: new Date().toString(),
                  modified: new Date().toString(),
                })
              )
            }
          }
        }
      }
    }

    if (userDocumentsToAdd.length > 0) {
      await helpers.asyncWhileLoop({
        loopCount: userDocumentsToAdd?.length ?? 0,
        functionToFire: async (currIndex) => {
          id = await createUserDocuments(
            new UserDocumentModel(userDocumentsToAdd![currIndex]).toFirestore()
          )
          userDocumentsToAdd![currIndex] = getConvertedData({
            ...userDocumentsToAdd![currIndex],
            id: id ?? null,
          })
        },
      })
    }

    if (userDocumentsToUpdate.length > 0) {
      await helpers.asyncWhileLoop({
        loopCount: userDocumentsToUpdate?.length ?? 0,
        functionToFire: async (currIndex) => {
          await updateUserDocuments({
            ...new UserDocumentModel(userDocumentsToUpdate![currIndex]).toFirestore(),
            id: userDocumentsToUpdate![currIndex].id,
          })
        },
      })
    }
  } catch (error) {
    console.error(error, 'error')
  }
}
